import React from "react";
import Header from "../components/Header";
import Main from "../components/Main";
import Footer from "../components/Footer";

function Home(){
    return(
        <>
        <Header />
        <Main />
        <Footer />

        </>
    );
}

export default Home; 